import React, { useState } from "react";
import {
    Button,
    Icon,
    Input,
    message,
    Modal,
    Select,
    Table,
    Tooltip
} from "antd";
import style from "./index.module.scss";
import {
    ColumnProps,
    TableRowSelection,
    SortOrder
} from "antd/lib/table/interface";
import {
    copyQuestion,
    CourseInfoItem,
    getQuestionDatabaseList,
    QuestionBaseList
} from "service/exercise";
import { errorMessage } from "service/service";
import { useParams } from "react-router-dom";
import { SorterResult } from "antd/lib/table/interface";
import { ResultMessage } from "components/ResultMessage";
import useRequestFn from "utils/useRequestFn";
import Moment from "moment";
import { useUpdateEffect } from "react-use";
import { useTopicTypes } from "../../../../../service/stores/Exercise/ExerciseTypes";
import { htmlToPlain, replaceImgTag } from "../../../../../utils/common";
import TopicPreview from "./Components/TopicPreview";
import { question2Exercise } from "./utils";

interface TopicCloneModalProps {
    visible: boolean;
    onCancel: () => void;
    onOk: () => void;
    courseInfoList: CourseInfoItem[];
}

export default function TopicCloneModal({
    visible,
    onCancel,
    onOk,
    courseInfoList
}: TopicCloneModalProps) {
    const { Option } = Select;
    const { id } = useParams<{ id: string }>(); //当前练习活动id
    const [courseSelected, setCourserSelected] = useState([]); //所选课程
    const [topicType, setTopicType] = useState([]); //所选题型
    const [keyWord, setKeyWord] = useState(""); //输入的关键词
    const [selectedParams, setSelectedParams] = useState<
        { questionId: string; exerciseId: string }[]
    >([]); //多选选中项参数
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[] | number[]>(
        []
    ); //当前多选选中项(显示)
    const [pageNum, setPageNum] = useState(1); //当前页
    const [pageSize, setPageSize] = useState<number>(10); //每页的条数
    const [sortName, setSortName] = useState("createTime"); //排序字段名:创建时间createTime 修改时间updateTime
    const [sortType, setSortType] = useState("2"); //排序规则:0：降序, 1：升序 ,2：默认
    const sortDirections: SortOrder[] = ["descend", "ascend"];
    const [list, setList] = useState<QuestionBaseList[]>([]);
    const [noSearch, setNoSearch] = useState(true); //通过noSearch判断当前是不是未查询之前的状态，是则显示“请输入查询条件后查询”否则显示“无数据”

    const topicTypeList = useTopicTypes();

    const [getData, { loading: loadingData, data }] = useRequestFn(
        getQuestionDatabaseList
    );

    async function handleSearch() {
        try {
            await updateData();
            handleInitial();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    async function updateData() {
        const params = {
            search: keyWord,
            pageSize,
            currPage: pageNum,
            exerciseId: Number(id),
            sortName,
            sortType,
            courseId: courseSelected.join(),
            queTypeId: topicType.join()
        };
        const data = await getData({ ...params });
        setList(data?.list);
        setNoSearch(false);
    }

    //点击查询后初始化页面，创建时间显示倒序
    function handleInitial() {
        setPageNum(1);
        setSortType("0");
        setSelectedParams([]);
        setSelectedRowKeys([]);
    }

    useUpdateEffect(() => {
        if (visible) updateData();
    }, [pageSize, pageNum, sortName, sortType]);

    const onTableChange = (
        pagination: any,
        filters: any,
        sorter: SorterResult<any>
    ) => {
        setSortName(sorter.columnKey);
        setSortType(
            sorter.order === "ascend"
                ? "1"
                : sorter.order === "descend"
                ? "0"
                : "2"
        );
        setPageNum(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const columns: ColumnProps<QuestionBaseList>[] = [
        {
            title: "课程信息",
            dataIndex: "courseNo",
            align: "left",
            render: (text, record) => (
                <div className={style.column}>
                    <Tooltip
                        placement="topLeft"
                        title={`[${text}-${record.courseSeq}]${record.courseName}`}>
                        [{text}-{record.courseSeq}]{record.courseName}
                    </Tooltip>
                </div>
            )
        },
        {
            title: "题型",
            dataIndex: "queTypeDescription",
            align: "center",
            render: text => (
                <div className={style.column}>
                    <Tooltip
                        placement="topLeft"
                        title={text}
                        overlayClassName={style.overlayStyle}>
                        {text}
                    </Tooltip>
                </div>
            )
        },
        {
            title: "题干",
            dataIndex: "questionDescription",
            align: "left",
            render: text => (
                <div>
                    <Tooltip
                        placement="topLeft"
                        title={
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: htmlToPlain(text, replaceImgTag)
                                }}
                            />
                        }
                        overlayClassName={style.overlayStyle}>
                        <div
                            className={style.column}
                            dangerouslySetInnerHTML={{
                                __html: htmlToPlain(text, replaceImgTag)
                            }}
                        />
                    </Tooltip>
                </div>
            )
        },
        {
            title: "分类",
            dataIndex: "paperType",
            align: "center",
            render: text => <div>{text === "0" ? "练习题目" : "作业题目"}</div>
        },
        {
            title: "创建时间",
            dataIndex: "createTime",
            align: "center",
            sorter: true,
            sortDirections: sortDirections,
            sortOrder:
                sortName === "createTime" &&
                (sortType === "0"
                    ? "descend"
                    : sortType === "1"
                    ? "ascend"
                    : false),
            render: text => (
                <div>{Moment(text).format("YY/MM/DD HH:mm:ss")}</div>
            )
        },
        {
            title: "更新时间",
            dataIndex: "updateTime",
            align: "center",
            sorter: true,
            sortDirections: sortDirections,
            sortOrder:
                sortName === "updateTime" &&
                (sortType === "0"
                    ? "descend"
                    : sortType === "1"
                    ? "ascend"
                    : false),
            render: text => (
                <div>
                    {text[0] === "0"
                        ? ""
                        : Moment(text).format("YY/MM/DD HH:mm:ss")}
                </div>
            )
        }
    ];

    const pagination = {
        current: pageNum,
        total: list.length === 0 ? 0 : data?.allCount,
        pageSize: pageSize,
        pageSizeOptions: ["10", "20", "50", "100"],
        showSizeChanger: true,
        hideOnSinglePage: false,
        showQuickJumper: true,
        showTotal: (total: number) => <span>总计{total}条</span>
    };

    const rowSelection: TableRowSelection<QuestionBaseList> = {
        type: "checkbox",
        selectedRowKeys,
        onChange: (selectedRowKeys: string[] | number[]) => {
            setSelectedRowKeys(selectedRowKeys);
        },

        onSelect: (record, selected) => {
            const params = {
                questionId: String(record.questionId),
                exerciseId: String(record.exerciseId)
            };
            selected
                ? setSelectedParams([...selectedParams, params])
                : setSelectedParams(
                      selectedParams.filter(
                          item => item.questionId !== params.questionId
                      )
                  );
        },

        onSelectAll: (selected, selectedRows, changeRows) => {
            const params = changeRows.map((item: any) => ({
                questionId: String(item.questionId),
                exerciseId: String(item.exerciseId)
            }));
            if (selected) {
                setSelectedParams([...selectedParams, ...params]);
            } else {
                const list = selectedParams.filter(rows =>
                    params.every(
                        (item: any) => item.questionId !== rows.questionId
                    )
                );
                setSelectedParams([...list]);
            }
        }
    };

    async function addHandler() {
        try {
            await copyQuestion(JSON.stringify(selectedParams), id);
            ResultMessage.success("添加成功!");
            onOk();
            onCancel();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    //点击关闭后初始化
    function onReset() {
        setCourserSelected([]);
        setTopicType([]);
        setKeyWord("");
        setSelectedParams([]);
        setSelectedRowKeys([]);
        setSortType("2");
        setSortName("createTime");
        setList([]);
        setNoSearch(true);
        setPageSize(10);
    }

    const footer = (
        <div className={style.footer}>
            <div className={style.footerCount}>
                已选择 <em>{selectedParams.length}</em> 题
            </div>

            <div className={style.footerButtons}>
                <Button type="default" onClick={onCancel}>
                    取消
                </Button>
                <Button
                    type="primary"
                    onClick={addHandler}
                    disabled={selectedParams.length === 0}>
                    确认
                </Button>
            </div>
        </div>
    );

    return (
        <Modal
            title="选择题目"
            width={1200}
            visible={visible}
            className={style.root}
            footer={footer}
            maskClosable={false}
            onCancel={onCancel}
            afterClose={onReset}>
            <div className={style.header}>
                <div className={style.left}>
                    <div className={style.leftItem}>
                        <span className={style.subTitle}>课程信息</span>
                        <Select
                            mode="multiple"
                            allowClear
                            placeholder="请选择课程"
                            onChange={(e: any) => setCourserSelected(e)}
                            className={style.multipleCheck}
                            value={courseSelected}
                            maxTagCount={2}
                            dropdownClassName={style.dropdown}>
                            {courseInfoList &&
                                courseInfoList.map(item => (
                                    <Option key={item.id}>
                                        {item.courseNo}
                                        {item.courseSeq}
                                        {item.courseName}
                                    </Option>
                                ))}
                        </Select>
                    </div>

                    <div className={style.rightItem}>
                        <span className={style.subTitle}>题型</span>
                        <Select
                            mode="multiple"
                            allowClear
                            placeholder="请选择题型"
                            onChange={(e: any) => setTopicType(e)}
                            className={style.multipleCheck}
                            value={topicType}
                            maxTagCount={2}
                            dropdownClassName={style.dropdown}>
                            {topicTypeList &&
                                topicTypeList.map(item => (
                                    <Option key={item.id}>
                                        {item.description}
                                    </Option>
                                ))}
                        </Select>
                    </div>
                </div>
                <div className={style.right}>
                    <Input
                        className={style.input}
                        placeholder="请输入题干关键词"
                        value={keyWord}
                        onChange={e => setKeyWord(e.target.value)}
                    />
                    <Button
                        type="primary"
                        className={style.button}
                        onClick={handleSearch}>
                        <Icon type="search" /> 查询
                    </Button>
                </div>
            </div>

            <div className={style.body}>
                <Table
                    columns={columns}
                    rowKey="questionId"
                    dataSource={list}
                    pagination={pagination}
                    rowSelection={rowSelection}
                    scroll={{ y: 411 }}
                    loading={loadingData}
                    onChange={onTableChange}
                    locale={{
                        emptyText: (
                            <div className={style.empty}>
                                {noSearch ? "请输入查询条件后查询" : "无数据"}
                            </div>
                        )
                    }}
                    expandRowByClick
                    expandedRowRender={data => (
                        <TopicPreview
                            questionId={data.questionId}
                            data={question2Exercise(data)}
                        />
                    )}
                />
            </div>
        </Modal>
    );
}
